import React from 'react';
import { cn } from '@strivelabs/ui-core';
import { sanitizeForCSSVar } from '../../lib/chartCssUtils';

export interface ChartConfig {
  [key: string]: {
    label?: string;
    color?: string;
  };
}

export interface ChartContainerProps {
  children: React.ReactNode;
  config: ChartConfig;
  className?: string;
}

export const ChartContainer: React.FC<ChartContainerProps> = ({
  children,
  config,
  className,
}) => {
  return (
    <div
      className={cn('w-full', className)}
      style={
        {
          '--color-primary': 'hsl(var(--primary))',
          '--color-secondary': 'hsl(var(--secondary))',
          '--color-accent': 'hsl(var(--accent))',
          '--color-muted': 'hsl(var(--muted))',
          ...Object.entries(config).reduce((acc, [key, value]) => {
            if (value.color) {
              // Sanitize the key for CSS variable name
              const sanitizedKey = sanitizeForCSSVar(key);
              acc[`--color-${sanitizedKey}`] = value.color;
            }
            return acc;
          }, {} as Record<string, string>),
        } as React.CSSProperties
      }
    >
      {children}
    </div>
  );
};